import React, {useState, useEffect} from "react"
import './App.scss';

import Header from './components/header/header';
import Home from './sections/home/Home';
import Tickets from './sections/tickets/tickets';
import Visit from './sections/visit/visit';
import Animals from './sections/animals/animal';
import Events from './sections/events/events';
import Team from './sections/team/team';
import Promotions from './sections/promotions/promotions';

import Footer from './components/footer/footer';
import Modal from './components/modal/modal';

import logo from './assets/triassicpark-logo-S.png';
import logoT from './assets/logo-text.jpg';

function App() {

  const [scroll, setScroll] = useState(false);
  const [modalConfig, setModal] = useState({open: false, content: undefined});
  const [modal10k, setModal10k] = useState(false);
  const [fistRender, setFistRender] = useState(true);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY);
    });
  }, []);

  useEffect(() => {
    if (document) {
      document.body.style.overflow = modalConfig.open ? 'hidden' : 'auto';
    }
  }, [modalConfig])

  const handleModal = (config) => {
    config.content === '10k' ? setModal10k(false) : setModal(config);
  }

  useEffect(() => {
    if(fistRender) {
      setTimeout(() => {
        setModal10k(true);
      }, 120000);
    }else{
      setFistRender(false);
    };
  }, [fistRender])
  
  const headerFixed = scroll > 50;
  const logoImg = scroll? logoT : logo;


  const today = new Date();
  // Date of the latest death
  const latestEvent = new Date(2023, 6, 11); //month is index of array of months starting on 0.  
  const timeDiference = today - latestEvent;
  const days = Math.floor(timeDiference / (1000*60*60*24));
  console.log('aaa Days segundos', days);

  return (
    <div className="App">
      <Header logo={logoImg} headerFixed={headerFixed}/>
      <div className="days">
        Días sin accidentes: 
        <span>{days}</span>
      </div>
      <main className={"App-main"}>
        <Home/>
        <Tickets/>
        <Visit/>
        <Animals/>
        <Events/>
        <Team/>
        <Promotions handleModal={handleModal}/>
      </main>
      <Footer handleModal={handleModal}/>
      <div className="credits">
        <p>
          Algunas de las imagen pertenecen a:
        </p>
        <div>
          <a href="https://www.freepik.es/vector-gratis/conjunto-realista-emblemas-premio-laurel-corona-sobre-fondo-negro-aislado_15405494.htm#from_view=detail_author">
          Imagen de macrovector</a> en Freepik
        </div>
        <div>
          <a href="https://www.freepik.es/foto-gratis/sendero-hormigon-parque-natural_21520675.htm#query=dinosaurio&position=8&from_view=search&track=sph">Imagen de tawatchai07</a> en Freepik
        </div>
        <div>
          Imagen de <a href="https://www.freepik.es/vector-gratis/concepto-error-404-esqueletos-dinosaurios_1535154.htm#page=4&query=dinosaurio&position=36&from_view=search&track=sph">Freepik</a>
        </div>
      </div>

      <Modal config={modalConfig} handleModal={handleModal} />
      <Modal config={{open: modal10k, content:'10k'}} handleModal={handleModal} />
    </div>

);
}

export default App;
